import React, { memo } from "react";

import BaseNode from "../Base/Base";
import type AssetTypes from "../../../../../../../enums/assetTypes";
import { type FlowItemLink } from "../../../types";
import { type FlowItemBase } from "../types";
import LinkCard from "components/cards/flowDesignerDropCard/LinkCard/LinkCard";

interface ILinkNodeOwnProps {
  type: AssetTypes.Link;
  data: FlowItemLink & FlowItemBase;
}

const LinkNode: React.FC<ILinkNodeOwnProps> = ({ type, data }) => {
  return (
    <BaseNode data={data}>
      <LinkCard item={{ ...data, elementType: type }} />
    </BaseNode>
  );
};

export default memo(LinkNode);
